import { logUsage } from 'owa-analytics';
import { parse as parseUrl } from 'url';

export function isLinkPrefixedWithBaseUrl(linkUrl: string, baseUrl: string): boolean {
    let linkHostName: string;

    // This throws about 300 exceptions per day. If that number increases we should look into finding and fixing the root cause
    // but for now a try catch is an acceptable work around.
    try {
        linkHostName = parseUrl(linkUrl).hostname;
    } catch {
        logUsage('isLinkPrefixedWithBaseUrl');
        return false;
    }

    const baseHostName: string = parseUrl(baseUrl).hostname;

    return linkHostName === baseHostName && linkUrl !== baseUrl;
}
